export default __webpack_public_path__ + "static/media/event-countdown-timer.93aaf672.png";